import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import {
  acceptRejectOffer,
  buyerDeleteDocument,
  cancelSeparationToUser,
  confirmDocuments,
  confirmLastPayment,
  confirmNotaryPayment,
  getChat as getChatFromApi,
  getChatList,
  getChatMessages as getChatMessagesFromApi,
  //getOfferByProperty,
  getPropertyDraftPromesaCompraVenta,
  getSeparationByProperty,
  sellerApproveSeparationPayment,
  sellerCancelPurchaseProcess,
  sellerConfirmDocuments,
  sellerConfirmLastPayment,
  sellerConfirmNotaryPayment,
  sellerDeleteDocument,
  //sellerGetOfferByUser,
  sellerMakeOfferToUser,
  sendChatAdminMessage,
  sendChatMessage,
  uploadBuyerDocuments,
  uploadGeneral,
  uploadSellerDocuments,
} from '../api';
import Button from '../components/core/Button';
import Wrapper from '../components/core/Wrapper';
import AcceptOfferModal from '../components/Messages/AcceptOfferModal';
import ChatCard from '../components/Messages/ChatCard';
import DocumentsModal from '../components/Messages/DocumentsModal';
import OfferFormModal from '../components/Messages/OfferFormModal';
import SeparatePropertyModal from '../components/Messages/SeparatePropertyModal';
import BankAccountModal from '../components/Modals/BankAccountModal';
import YesNoPrompt from '../components/Modals/YesNoPrompt';
import Appointment from '../components/Modals/Appointment';
import { Property } from '../components/Property/Property';
import { handleGlobalApiCalls } from '../helpers/asyncActions';
import { getProfilePic } from '../helpers/images';
import { getFormattedPrice } from '../helpers/price';
import { getRelativeTimeInfo } from '../helpers/time';
//import { open } from '../helpers/wompi';
import SendIcon from '../images/icons/send.svg';
import { useGlobalContext } from '../stores/global';
import styles from './Messages.module.scss';
import { getUser } from '../helpers/storage';
import CancelFormModal from '../components/Messages/CancelFormModal';

export default function Messages(props: any) {
  const [chatObj, setChatObj] = useState<any>();
  const [chatMessages, setChatMessages] = useState<any>();
  const [chats, setChats] = useState<any>();
  const { handleSubmit, register, setValue } = useForm();
  const { user, isLoading, dispatch } = useGlobalContext();
  const [offer, setOffer] = useState<any>();
  const [separation, setSeparation] = useState<any>();
  const [showOfferFormModal, setShowOfferFormModal] = useState(false);
  const [showCancelFormModal, setShowCancelFormModal] = useState(false);
  const [headerMessage, setHeaderMessage] = useState('...');
  const [showDocumentsModal, setShowDocumentsModal] = useState(false);
  const inputMessageRef = useRef<HTMLInputElement | null>(null);
  const messagesContainerContentRef = useRef<HTMLDivElement>(null);
  const [showAcceptOfferModal, setShowAcceptOfferModal] = useState(false);
  const [showBankAccountModal, setShowBankAccountModal] = useState(false);
  const chatMessagesPollingIntervalRef = useRef<number>();
  const chatPollingIntervalRef = useRef<number>();
  const [showPurchasePropertyModal, setShowPurchasePropertyModal] = useState(
    false
  );
  const [yesNoPromptProps, setYesNoPromptProps] = useState<{
    title: string;
    text: string;
    onClose: () => void;
    onYes: () => void;
  }>();
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);

  if (!user) return null;

  useEffect(() => {
    handleGlobalApiCalls(dispatch, isLoading, null, () =>
      getChatList().then((response) => {
        let news = response.data.data?.docs
          .filter((a: any) => a.lastMessage?._id?.status === 'sent')
          .sort((a: any, b: any) =>
            b.lastMessage?.createdAt.localeCompare(a.lastMessage?.createdAt)
          );
        let normal = response.data.data?.docs
          .filter((a: any) => a.lastMessage?._id?.status === 'read')
          .sort((a: any, b: any) =>
            b.lastMessage?.createdAt.localeCompare(a.lastMessage?.createdAt)
          );
        let empty = response.data.data?.docs
          .filter((a: any) => !a.lastMessage)
          .sort((a: any, b: any) => b.createdAt.localeCompare(a.createdAt));
        setChats([...news, ...normal, ...empty]);
      })
    );
  }, []);

  // On chat selected
  useEffect(() => {
    /*Prevent at test set null*/
    setOffer(null);
    const chatId = props.match.params.chatId;

    if (!chatId) {
      setHeaderMessage('MENSAJES');
      window.clearInterval(chatMessagesPollingIntervalRef.current);
      window.clearInterval(chatPollingIntervalRef.current);
      return;
    }

    handleGlobalApiCalls(dispatch, isLoading, null, () =>
      Promise.resolve()
        .then(() => {
          setChatObj(null);
          setHeaderMessage('...');
        })
        .then(() => Promise.all([getChat(chatId), getChatMessages(chatId)]))
        .then(() => startChatMessagesPolling())
        .then(() => startChatPolling())
        .catch((err) => {
          setChatObj(null);
          throw err;
        })
    );

    return () => {
      window.clearInterval(chatMessagesPollingIntervalRef.current);
      window.clearInterval(chatPollingIntervalRef.current);
    };
  }, [props.match.params.chatId]);

  useEffect(() => {
    scrollMessagesContainerContentToBottom();
  }, [chatMessages]);

  const parseOffer = (offer: any) => {
    if (!offer?.id || offer?.status === 'cancelada') return;

    return offer;
  };

  // Polling chat status
  const startChatPolling = () => {
    window.clearInterval(chatPollingIntervalRef.current);
    chatPollingIntervalRef.current = window.setInterval(() => {
      const chatId = props.match.params.chatId;
      if (chatId) getChat(chatId);
      // }, 5000 * 100000); // TODO: enable polling again
    }, 5000);
  };

  // Polling chat messages
  const startChatMessagesPolling = () => {
    window.clearInterval(chatMessagesPollingIntervalRef.current);
    chatMessagesPollingIntervalRef.current = window.setInterval(() => {
      const chatId = props.match.params.chatId;
      if (chatId) getChatMessages(chatId);
      // }, 5000 * 100000); // TODO: enable polling again
    }, 5000);
  };

  const getChatMessages = (chatId: string) => {
    getChatList().then((response) => {
      let news = response.data.data?.docs
        .filter((a: any) => a.lastMessage?._id?.status === 'sent')
        .sort((a: any, b: any) =>
          b.lastMessage?.createdAt.localeCompare(a.lastMessage?.createdAt)
        );
      let normal = response.data.data?.docs
        .filter((a: any) => a.lastMessage?._id?.status === 'read')
        .sort((a: any, b: any) =>
          b.lastMessage?.createdAt.localeCompare(a.lastMessage?.createdAt)
        );
      let empty = response.data.data?.docs
        .filter((a: any) => !a.lastMessage)
        .sort((a: any, b: any) => b.createdAt.localeCompare(a.createdAt));
      setChats([...news, ...normal, ...empty]);
    });
    return getChatMessagesFromApi(chatId, {
      sort: '{"updatedAt":"desc"}',
    }).then((response) => {
      const messages = response.data.data?.docs || [];
      setChatMessages([...messages].reverse().map((el) => el));
    });
  };

  const getChat = (chatId: string) => {
    return getChatFromApi(chatId)
      .then((response) => {
        const parsedChat = parseChat(response.data.data);
        setChatObj(parsedChat);
        setHeaderMessage(
          (parsedChat.receiverUserId.toString() ===
          parsedChat.property.user.toString()
            ? 'Vendedor: '
            : 'Comprador: ') + parsedChat.receiverName
        );

        if (!parsedChat.property?.id) return;
        /* if (parsedChat.property.user === user.id)
          return sellerGetOfferByUser(
            parsedChat.property.id,
            parsedChat.receiverUserId
          ); */

        //return getOfferByProperty(parsedChat.property.id);
        return getSeparationByProperty(parsedChat.property.id);
      })
      .then((response) => {
        setSeparation(parseOffer(response?.data.data));
      });
  };

  const parseChat = (chat: any) => {
    let messageText = '';
    let receiverUserId = '';
    let receiverName = '';
    let amITheSeller: boolean;
    const time = getRelativeTimeInfo(
      new Date(chat.updatedAt || chat.createdAt)
    );

    if (chat.lastMessage) {
      messageText = chat.lastMessage.message;
    }

    if (user.id === chat.from?.id) {
      receiverName = chat.to?.name;
      receiverUserId = chat.to?.id;
      amITheSeller = false;
    } else {
      receiverName = chat.from?.name;
      receiverUserId = chat.from?.id;
      amITheSeller = true;
    }

    return {
      id: chat.id,
      messageText,
      time,
      receiverName,
      receiverUserId,
      amITheSeller,
      attaches: chat.attaches,
      property: {
        ...chat.property,
        purchaseProcess: chat.property?.purchaseProcess || [],
      },
    };
  };

  const parseChatMessage = (message: any) => {
    let messageText = '';
    let time = getRelativeTimeInfo(new Date(message.createdAt));
    let isFromMe = false;
    const name = message.user?.name;
    const photo = message.user?.photo;

    if (message) {
      messageText = message.message;
    }

    return { messageText, time, isFromMe, name, photo };
  };

  const scrollMessagesContainerContentToBottom = () => {
    if (!messagesContainerContentRef.current) return;

    messagesContainerContentRef.current.scrollTop =
      messagesContainerContentRef.current.scrollHeight;
  };

  const handleMessageSubmit = (data: any) => {
    inputMessageRef.current?.focus();
    const message = data.message.trim();

    const chatId = chatObj?.id;

    if (!chatId || !message) {
      setValue('message', '');
      return;
    }

    // TODO: para cancelar el proceso de compra
    if (message === 'cancelar') {
      handleGlobalApiCalls(dispatch, isLoading, null, () =>
        sellerCancelPurchaseProcess(chatObj.property.id).then(
          () => (window.location.href = '/messages')
        )
      );

      return;
    }

    setValue('message', '');

    sendChatMessage(chatId, message).then((response) => {
      const message = response.data.data;

      setChatMessages([...chatMessages, { ...message, user }]);
    });
  };

  const handleMessageAdminSubmit = (data: any) => {
    inputMessageRef.current?.focus();
    const message = data.message.trim();

    const chatId = chatObj?.id;

    if (!chatId || !message) {
      setValue('message', '');
      return;
    }

    setValue('message', '');

    sendChatAdminMessage(chatId, message).then((response) => {
      const message = response.data.data;

      setChatMessages([...chatMessages, { ...message, user }]);
    });
  };

  /* const getOfferDetails = (offer: any) => {
    return (
      <>
        <p>
          <b>Precio de venta: </b>
          {getFormattedPrice(offer?.offer)}
        </p>
        <p>
          <b>Estado: </b>
          {offer?.status}
        </p>
      </>
    );
  }; */

  const handleOfferSubmit = (price: number) => {
    return handleGlobalApiCalls(dispatch, isLoading, null, () =>
      sellerMakeOfferToUser(chatObj.receiverUserId, chatObj.property.id, {
        price,
      })
        .then(() => getChat(props.match.params.chatId))
        .then(() =>
          handleMessageSubmit({
            message: `Nueva Oferta por valor de $${price}`,
          })
        )
        .then(() => setShowOfferFormModal(false))
    );
  };

  const handleCancelSubmit = () => {
    return handleGlobalApiCalls(dispatch, isLoading, null, () =>
      cancelSeparationToUser(separation.id, chatObj.property.id)
        .then(() => getChat(props.match.params.chatId))
        .then(() =>
          handleMessageAdminSubmit({
            message: `Separación cancelada por el vendedor`,
          })
        )
        .then(() => setShowCancelFormModal(false))
    );
  };

  const handleAcceptRejectOffer = (status: 'aceptada' | 'rechazada') => {
    return handleGlobalApiCalls(dispatch, isLoading, null, () =>
      acceptRejectOffer(chatObj.property.id, status)
        .then(() => getChat(props.match.params.chatId))
        .then(() => handleMessageSubmit({ message: `Oferta ${status}` }))
        .then(() => setYesNoPromptProps(undefined))
        .then(() => setShowAcceptOfferModal(false))
    );
  };

  const handleDocumentUpload = (
    type: 'seller' | 'buyer',
    name: string,
    evt: any
  ) => {
    const file = evt.currentTarget.files?.[0];
    const apiEndpoint =
      type === 'seller' ? uploadSellerDocuments : uploadBuyerDocuments;

    if (!file) return;

    const bodyFormData = new FormData();
    bodyFormData.append('file', file);

    return handleGlobalApiCalls(dispatch, isLoading, null, () =>
      uploadGeneral(bodyFormData).then((response) =>
        apiEndpoint(chatObj.property.id, {
          ...response.data.data,
          name: name,
        }).then(() => getChat(props.match.params.chatId))
      )
    );
  };

  const handleDeleteDocument = (
    type: 'seller' | 'buyer',
    propertyId: string,
    documentId: string
  ) => {
    const apiEndpoint =
      type === 'seller' ? sellerDeleteDocument : buyerDeleteDocument;

    return handleGlobalApiCalls(dispatch, isLoading, null, () =>
      apiEndpoint(propertyId, documentId).then(() =>
        getChat(props.match.params.chatId)
      )
    );
  };

  const getUploadDocumentsEl = (
    id: string,
    isSeller: boolean,
    additional: any
  ) => {
    const type = isSeller ? 'seller' : 'buyer';

    const uploadedDocs =
      (isSeller && additional.sellerStatus === 'completed') ||
      (!isSeller && additional.buyerStatus === 'completed');

    return (
      <div className={styles.stepContent} key={id}>
        <h1>Subir documentos</h1>
        <p>
          Sube los siguientes documentos para que sean verificados por un
          notario (* son obligatorios):
        </p>
        {additional[type].map((el: any) => (
          <div key={el.name} style={{ marginBottom: 20 }}>
            <p>
              <b>
                {el.name}
                {el.required ? '*' : ''}
              </b>
            </p>
            {(() => {
              const document = chatObj.property.deedDocuments[type].find(
                (el2: any) => el2.name === el.name
              );

              if (document) {
                return (
                  <p>
                    {el.name}{' '}
                    <a
                      onClick={handleDeleteDocument.bind(
                        null,
                        type,
                        chatObj.property.id,
                        document._id
                      )}
                    >
                      Eliminar
                    </a>
                  </p>
                );
              }

              return (
                <input
                  type="file"
                  onChange={handleDocumentUpload.bind(null, type, el.name)}
                />
              );
            })()}
          </div>
        ))}

        {!uploadedDocs && (
          <p>
            Una vez hayas subido todos los documentos, dale click a Confirmar
          </p>
        )}

        {uploadedDocs && (
          <p style={{ fontStyle: 'italic' }}>
            Nota: Esperando a que el {isSeller ? 'comprador' : 'vendedor'}{' '}
            confirme también que subió sus documentos
          </p>
        )}

        <Button
          label={uploadedDocs ? 'VOLVER A CONFIRMAR' : 'CONFIRMAR'}
          onClick={() => {
            sellerConfirmDocuments;
            const confirmDocumentsFn = isSeller
              ? sellerConfirmDocuments
              : confirmDocuments;

            handleGlobalApiCalls(dispatch, isLoading, null, () =>
              confirmDocumentsFn(chatObj.property.id)
                .then(() => getChat(props.match.params.chatId))
                .then(() =>
                  handleMessageSubmit({ message: 'Documentos enviados' })
                )
            );
          }}
        />
      </div>
    );
  };

  /* const handleWompiPay = (reservedPrice: number) => {
    if (!offer?.id) return;
    if (!chatObj?.id) return;

    open({
      reference: `${offer.id}_${Math.round(Math.random() * 9999)}`,
      chatId: chatObj.id,
      amountInPesos: reservedPrice,
    });
  }; */

  const getBankAccountInfo = (bankAccount: any) => {
    if (!bankAccount) return null;

    return (
      <p>
        <b>Banco: </b>
        {bankAccount.bank}
        <br />
        <b>Tipo de cuenta: </b>
        {bankAccount.type}
        <br />
        <b>Número de cuenta: </b>
        {bankAccount.account}
        <br />
      </p>
    );
  };

  const getBorradorPromesaLinkEl = () => {
    return (
      <p>
        Aquí puedes ver el{' '}
        <a
          onClick={() => {
            if (!chatObj?.property?.id) return;

            handleGlobalApiCalls(dispatch, isLoading, null, async () => {
              const response = await getPropertyDraftPromesaCompraVenta(
                chatObj.property.id
              );
              window.open(URL.createObjectURL(response.data));
            });
          }}
        >
          Borrador de la promesa de compraventa
        </a>
      </p>
    );
  };

  return (
    <Wrapper
      isFullScreen
      subHeader={{
        title: headerMessage,
        showBack: !!props.match.params.chatId,
      }}
      contentProps={{
        className: clsx(
          styles.content,
          props.match.params.chatId && styles.contentIsMessage
        ),
      }}
    >
      <section className={styles.usersContainer}>
        <div className={styles.sectionContent}>
          {!chats
            ? 'Cargando...'
            : (chats as any[]).length === 0
            ? 'No tienes mensajes'
            : (chats as any[]).map((chat, idx) => {
                const {
                  id,
                  messageText,
                  time,
                  receiverName,
                  amITheSeller,
                  property,
                } = parseChat(chat);

                return (
                  <ChatCard
                    isSelected={id === chatObj?.id}
                    isNewMessage={
                      chat?.lastMessage?._id.status === 'sent' &&
                      user.id !== chat?.lastMessage?.user
                    }
                    key={idx}
                    chatId={id}
                    message={messageText}
                    time={time}
                    name={receiverName}
                    isSeller={amITheSeller}
                    property={property}
                  />
                );
              })}
        </div>
      </section>

      {props.match.params.chatId && chatObj && (
        <section className={styles.messagesContainer}>
          <div
            className={styles.sectionContent}
            ref={messagesContainerContentRef}
          >
            {chatMessages &&
              (chatMessages as any[]).map((chatMessage, idx) => {
                const { name, messageText, time, photo } = parseChatMessage(
                  chatMessage
                );
                if (chatMessage.type === 'admin') {
                  return (
                    <div key={idx} className={styles.adminMessage}>
                      <div className={styles.userMessageContent}>
                        <b>{messageText}</b>
                        <h2>
                          <span>{time}</span>
                        </h2>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <div key={idx} className={styles.userMessage}>
                      <img src={getProfilePic(photo)} />
                      <div className={styles.userMessageContent}>
                        <h2>
                          {name}
                          <span>{time}</span>
                        </h2>
                        <p>{messageText}</p>
                        {user.id === chatMessage.user._id && (
                          <h2>
                            <span>
                              {chatMessage.status === 'sent'
                                ? 'Enviado'
                                : 'Visto'}
                            </span>
                          </h2>
                        )}
                      </div>
                    </div>
                  );
                }
              })}
          </div>

          <form
            className={styles.messageInputBox}
            onSubmit={handleSubmit(handleMessageSubmit)}
          >
            <input
              name="message"
              placeholder="Escribe un mensaje"
              autoComplete="off"
              ref={(e) => {
                inputMessageRef.current = e;
                // register's first argument is ref, and second is validation rules
                register(e, { required: true });
              }}
            />
            <button>
              <img src={SendIcon} />
            </button>
          </form>
        </section>
      )}

      {props.match.params.chatId && chatObj && (
        <section className={styles.detailsContainer}>
          <p className={styles.completedStep}>
            <i className="fonticons fonticons-copy" />
            <span>
              <a onClick={() => setShowDocumentsModal(true)}>
                Documentos compartidos
              </a>
            </span>
          </p>

          {/* Ninguna oferta realizada (Cambiar flujo vendedor)*/}
          {chatObj.property.purchaseProcess.length === 0 &&
            (!offer || offer.status === 'rechazada') &&
            !separation && (
              <div className={styles.stepContent}>
                {chatObj.amITheSeller ? (
                  <>
                    <h1>No se ha hecho ninguna separación</h1>
                    <p>No han hecho ninguna separación.</p>
                  </>
                ) : (
                  <>
                    <div className={styles.containerButton}>
                      <Button
                        className={styles.button1}
                        onClick={() => setShowPurchasePropertyModal(true)}
                        label="Separa la propiedad"
                      />
                    </div>
                    <div className={styles.containerButton}>
                      <Button
                        className={styles.button2}
                        spanProps={{ className: styles.span2 }}
                        label="Visita la propiedad"
                        onClick={() => setShowAppointmentModal(true)}
                      />
                    </div>
                  </>
                )}
              </div>
            )}

          {/* Separacion pagada y pendiente de negociacion por el comprador */}
          {chatObj.property.purchaseProcess.length === 0 && separation && (
            <div className={styles.stepContent}>
              {chatObj.amITheSeller ? (
                <>
                  <h1>PROPIEDAD SEPARADA</h1>
                  <Button
                    label="CANCELAR SEPARACIÓN"
                    onClick={() => setShowCancelFormModal(true)}
                  />
                </>
              ) : getUser()?.id === separation.user ? (
                <>
                  <h1>SEPARACIÓN EXITOSA</h1>
                </>
              ) : (
                <>
                  <h1>PROPIEDAD EN NEGOCIACIÓN</h1>
                </>
              )}
            </div>
          )}

          {/* Oferta realizada y pendiente de aceptación por el comprador */}
          {/* {chatObj.property.purchaseProcess.length === 0 &&
            offer &&
            offer.status !== 'rechazada' && (
              <div className={styles.stepContent}>
                {chatObj.amITheSeller ? (
                  <>
                    <h1>Estado de la oferta</h1>
                    {getOfferDetails(offer)}

                    <p>
                      Puedes editar la oferta en cualquier momento, hasta que el
                      comprador la acepte o rechace
                    </p>
                    <Button
                      label="EDITAR OFERTA"
                      onClick={() => setShowOfferFormModal(true)}
                    />
                  </>
                ) : (
                  <>
                    <h1>Estado de la oferta</h1>
                    {getOfferDetails(offer)}

                    {chatObj.property.reservedPrice ? (
                      <>
                        <p>
                          Para continuar, debes cancelar el valor de separación
                          <b>
                            {getFormattedPrice(chatObj.property.reservedPrice, {
                              prefix: ' ',
                              sufix: ' ',
                            })}
                          </b>
                          y tendrás {chatObj.property.reservedDays} días para
                          completar el proceso.
                        </p>
                        <Button
                          label="PAGAR CON WOMPI"
                          style={{ marginRight: 5 }}
                          onClick={() =>
                            handleWompiPay(chatObj.property.reservedPrice)
                          }
                        />
                      </>
                    ) : (
                      <>
                        <p>Deseas aceptar la oferta o rechazarla?</p>
                        <Button
                          label="ACEPTAR"
                          style={{ marginRight: 5 }}
                          onClick={() => setShowAcceptOfferModal(true)}
                        />
                      </>
                    )}
                    <Button
                      label="RECHAZAR"
                      onClick={() =>
                        setYesNoPromptProps({
                          title: 'Rechazar oferta',
                          text: 'Seguro que deseas rechazar esta oferta?',
                          onClose: () => setYesNoPromptProps(undefined),
                          onYes: () => handleAcceptRejectOffer('rechazada'),
                        })
                      }
                    />
                  </>
                )}
              </div>
            )} */}

          {chatObj.property.notarialObservation && (
            <p className={styles.warningMessage}>
              <i className="fonticons fonticons-warning" />
              <span>
                <b>Observación de notaría:</b>{' '}
                {chatObj.property.notarialObservation}
              </span>
            </p>
          )}

          {/* Oferta aceptada o comprador compró a precio de pila */}
          {chatObj.property.purchaseProcess.length !== 0 &&
            (() => {
              let price = chatObj.property.prices.property;
              if (offer && offer.status !== 'rechazada') {
                // TODO: hice esto porque cuando se compra a precio de pila, si habia oferta
                // rechazada, esta no se actualiza/elimina
                price = offer.offer;
              }

              return (
                <p className={styles.completedStep}>
                  <i className="fonticons fonticons-checked" />
                  <span>
                    Precio final negociado:
                    <b>{getFormattedPrice(price, { prefix: ' ' })}</b>
                  </span>
                </p>
              );
            })()}

          {chatObj.property.purchaseProcess.map(
            ({ reference, status, additional, _id }: any) => {
              if (reference === 'separation_payment' && status === 'pending') {
                return chatObj?.amITheSeller ? (
                  <div className={styles.stepContent} key={_id}>
                    <h1>Pago de promesa de compraventa</h1>
                    <p>
                      Para continuar, debes confirmar el pago de promesa de
                      compraventa por parte del comprador por un valor de
                      <b>
                        {getFormattedPrice(
                          chatObj.property?.prices?.separationPayment,
                          { prefix: ' ', sufix: '. ' }
                        )}
                      </b>
                      a la siguiente cuenta:
                    </p>
                    {getBankAccountInfo(additional.bankAccount)}
                    <p>
                      <a onClick={() => setShowBankAccountModal(true)}>
                        Editar cuenta bancaria
                      </a>
                    </p>
                    <p>
                      Una vez confirmado, se generará la promesa de compraventa
                    </p>
                    {getBorradorPromesaLinkEl()}

                    <Button
                      label="CONFIRMAR PAGO"
                      onClick={() =>
                        setYesNoPromptProps({
                          title: 'Confirmar pago',
                          text:
                            'Seguro que deseas confirmar el pago de promesa de compraventa por parte del comprador?',
                          onClose: () => setYesNoPromptProps(undefined),
                          onYes: () =>
                            handleGlobalApiCalls(
                              dispatch,
                              isLoading,
                              null,
                              () =>
                                sellerApproveSeparationPayment(
                                  chatObj.property.id
                                )
                                  .then(() =>
                                    getChat(props.match.params.chatId)
                                  )
                                  .then(() =>
                                    handleMessageSubmit({
                                      message: 'Pago confirmado',
                                    })
                                  )
                                  .finally(() => setYesNoPromptProps(undefined))
                            ),
                        })
                      }
                    />
                  </div>
                ) : (
                  <div className={styles.stepContent} key={_id}>
                    <h1>Pago de promesa de compraventa</h1>
                    <p>
                      Para continuar, debes realizar el pago por adelantado,
                      para generar la promesa de compraventa, por un valor de
                      <b>
                        {getFormattedPrice(
                          chatObj.property?.prices?.separationPayment,
                          { prefix: ' ' }
                        )}
                      </b>
                      <span> a la siguiente cuenta:</span>
                    </p>

                    {getBankAccountInfo(additional.bankAccount)}

                    {getBorradorPromesaLinkEl()}
                    <p>
                      Una vez hecho el pago, notifícale al vendedor a través del
                      chat para que confirme y generar la promesa de
                      compraventa.
                    </p>
                  </div>
                );
              } else if (
                reference === 'separation_payment' &&
                status === 'approved'
              ) {
                return (
                  <p key={_id} className={styles.completedStep}>
                    <i className="fonticons fonticons-checked" />
                    <span>
                      Pago de promesa:
                      <b> Confirmado</b>
                    </span>
                  </p>
                );
              } else if (
                reference === 'purchase_promise' &&
                status === 'completed'
              ) {
                return (
                  <p key={_id} className={styles.completedStep}>
                    <i className="fonticons fonticons-checked" />
                    <span>
                      Promesa de compraventa:
                      <a href={additional.urlDocuments}> Descargar</a>
                    </span>
                  </p>
                );
              } else if (
                reference === 'upload_documents' &&
                status === 'pending'
              ) {
                return getUploadDocumentsEl(
                  _id,
                  chatObj.amITheSeller,
                  additional
                );
              } else if (
                reference === 'upload_documents' &&
                status === 'verifying'
              ) {
                return (
                  <p key={_id} className={styles.completedStep}>
                    <i className="fonticons fonticons-checked" />
                    <span>
                      Estado de documentos:
                      <b> En verificación</b>
                    </span>
                  </p>
                );
              } else if (
                reference === 'upload_documents' &&
                status === 'completed'
              ) {
                return (
                  <p key={_id} className={styles.completedStep}>
                    <i className="fonticons fonticons-checked" />
                    <span>
                      Estado de Documentos:
                      <b> Verificados</b>
                    </span>
                  </p>
                );
              } else if (
                reference === 'notary_payment' &&
                status === 'pending'
              ) {
                const hasVerified =
                  (chatObj.amITheSeller &&
                    additional.seller.status === 'completed') ||
                  (!chatObj.amITheSeller &&
                    additional.buyer.status === 'completed');

                return (
                  <div className={styles.stepContent} key={_id}>
                    <h1>Costos de notaría</h1>
                    <p>
                      Cancelar costos de notaría a través del siguiente link de
                      la notaría:{' '}
                      <a
                        href={chatObj.property.notary.bankLinkPayment}
                        target="_blank"
                      >
                        Pagar
                      </a>
                    </p>
                    {!hasVerified && (
                      <p>Una vez hayas realizado el pago, confirma el pago</p>
                    )}
                    {hasVerified && (
                      <p style={{ fontStyle: 'italic' }}>
                        Nota: Espera a que el
                        {chatObj.amITheSeller ? ' comprador ' : ' vendedor '}
                        verifique su pago también
                      </p>
                    )}

                    <Button
                      label={
                        hasVerified
                          ? 'CONFIRMAR PAGO DE NUEVO'
                          : 'CONFIRMAR PAGO'
                      }
                      onClick={() => {
                        const confirmNotaryPaymentFn = chatObj.amITheSeller
                          ? sellerConfirmNotaryPayment
                          : confirmNotaryPayment;

                        handleGlobalApiCalls(dispatch, isLoading, null, () =>
                          confirmNotaryPaymentFn(
                            chatObj.property.id,
                            `Nombre: ${user.name}`
                          ).then(() => getChat(props.match.params.chatId))
                        );
                      }}
                    />
                  </div>
                );
              } else if (
                reference === 'notary_payment' &&
                status === 'verifying'
              ) {
                return (
                  <p key={_id} className={styles.completedStep}>
                    <i className="fonticons fonticons-checked" />
                    <span>
                      Pago de la notaría:
                      <b> En verificación</b>
                    </span>
                  </p>
                );
              } else if (
                reference === 'notary_payment' &&
                status === 'completed'
              ) {
                return (
                  <p key={_id} className={styles.completedStep}>
                    <i className="fonticons fonticons-checked" />
                    <span>
                      Pago de la notaría:
                      <b> Completado</b>
                    </span>
                  </p>
                );
              } else if (reference === 'last_payment' && status === 'pending') {
                return chatObj?.amITheSeller ? (
                  <div className={styles.stepContent} key={_id}>
                    <h1>Último pago</h1>
                    <p>
                      Debes esperar a que el comprador realize el último pago y
                      confirme
                    </p>
                  </div>
                ) : (
                  <div className={styles.stepContent} key={_id}>
                    <h1>Último pago</h1>
                    <p>
                      Realiza el último pago por valor de{' '}
                      <b>
                        {getFormattedPrice(additional.price, { sufix: ' ' })}
                      </b>
                      <span> a la siguiente cuenta:</span>
                    </p>

                    {getBankAccountInfo(additional.bankAccount)}

                    <Button
                      label="CONFIRMAR PAGO"
                      onClick={() =>
                        setYesNoPromptProps({
                          title: 'Confirmar pago',
                          text: `Seguro que deseas confirmar el último pago por valor de ${getFormattedPrice(
                            additional.price
                          )}? Se le notificará al vendedor`,
                          onClose: () => setYesNoPromptProps(undefined),
                          onYes: () =>
                            handleGlobalApiCalls(
                              dispatch,
                              isLoading,
                              null,
                              () =>
                                confirmLastPayment(chatObj.property.id)
                                  .then(() =>
                                    getChat(props.match.params.chatId)
                                  )
                                  .then(() =>
                                    handleMessageSubmit({
                                      message: 'Último pago confirmado',
                                    })
                                  )
                                  .finally(() => setYesNoPromptProps(undefined))
                            ),
                        })
                      }
                    />
                  </div>
                );
              } else if (
                reference === 'last_payment' &&
                status === 'verifying'
              ) {
                return chatObj?.amITheSeller ? (
                  <div className={styles.stepContent} key={_id}>
                    <h1>Último pago</h1>
                    <p>
                      El comprador ha confirmado el último pago por valor de
                      <b>
                        {getFormattedPrice(additional.price, { prefix: ' ' })}
                      </b>
                    </p>
                    <p>Por favor verifica el pago</p>

                    <Button
                      label="CONFIRMAR PAGO"
                      onClick={() =>
                        setYesNoPromptProps({
                          title: 'Confirmar pago',
                          text: `Seguro que deseas confirmar el último pago por valor de ${getFormattedPrice(
                            additional.price
                          )} por parte del comprador?`,
                          onClose: () => setYesNoPromptProps(undefined),
                          onYes: () =>
                            handleGlobalApiCalls(
                              dispatch,
                              isLoading,
                              null,
                              () =>
                                sellerConfirmLastPayment(chatObj.property.id)
                                  .then(() =>
                                    getChat(props.match.params.chatId)
                                  )
                                  .then(() =>
                                    handleMessageSubmit({
                                      message: 'Último pago confirmado',
                                    })
                                  )
                                  .finally(() => setYesNoPromptProps(undefined))
                            ),
                        })
                      }
                    />
                  </div>
                ) : (
                  <div className={styles.stepContent} key={_id}>
                    <h1>Último pago</h1>
                    <p>
                      Debes esperar a que el vendedor confirme el último pago
                    </p>
                  </div>
                );
              } else if (
                reference === 'last_payment' &&
                status === 'completed'
              ) {
                return (
                  <p key={_id} className={styles.completedStep}>
                    <i className="fonticons fonticons-checked" />
                    <span>
                      Último pago:
                      <b> Completado</b>
                    </span>
                  </p>
                );
              } else if (
                reference === 'generate_legalization' &&
                status === 'pending'
              ) {
                return (
                  <div className={styles.stepContent} key={_id}>
                    <h1>Legalización compraventa</h1>
                    <p>Esperando la Legalización de compraventa</p>
                  </div>
                );
              }

              return null;
            }
          )}

          <div className={styles.propertyDetailBox}>
            <Property property={chatObj.property} />
          </div>
        </section>
      )}

      <OfferFormModal
        open={showOfferFormModal}
        offer={offer}
        property={chatObj?.property}
        onClose={() => setShowOfferFormModal(false)}
        onSubmit={handleOfferSubmit}
      />

      <CancelFormModal
        open={showCancelFormModal}
        separation={separation}
        property={chatObj?.property}
        onClose={() => setShowCancelFormModal(false)}
        onSubmit={handleCancelSubmit}
      />

      <DocumentsModal
        open={showDocumentsModal}
        chatObj={chatObj}
        me={user}
        onClose={() => setShowDocumentsModal(false)}
        onFileUploaded={async () => {
          handleGlobalApiCalls(dispatch, isLoading, null, () =>
            getChat(props.match.params.chatId)
          );
        }}
        onFileDeleted={async () => {
          handleGlobalApiCalls(dispatch, isLoading, null, () =>
            getChat(props.match.params.chatId)
          );
        }}
      />

      <YesNoPrompt
        open={Boolean(yesNoPromptProps)}
        onClose={() => setYesNoPromptProps(undefined)}
        {...yesNoPromptProps}
      />

      <AcceptOfferModal
        open={showAcceptOfferModal}
        offer={offer}
        property={chatObj?.property}
        onClose={() => setShowAcceptOfferModal(false)}
        onSubmit={() => handleAcceptRejectOffer('aceptada')}
      />

      <BankAccountModal
        open={showBankAccountModal}
        user={user}
        onClose={() => setShowBankAccountModal(false)}
        onSubmit={() =>
          handleGlobalApiCalls(dispatch, isLoading, null, () =>
            getChat(props.match.params.chatId)
          )
        }
      />

      {/* <PurchasePropertyModal
        open={showPurchasePropertyModal}
        property={chatObj?.property}
        onSubmit={() =>
          handleGlobalApiCalls(dispatch, isLoading, null, () =>
            purchaseProperty(chatObj.property?.id)
              .then(() => getChat(props.match.params.chatId))
              .then(() =>
                handleMessageSubmit({
                  message: 'Comprado a precio de pila',
                })
              )
              .then(() => setShowPurchasePropertyModal(false))
          )
        }
        onClose={() => setShowPurchasePropertyModal(false)}
      /> */}

      <SeparatePropertyModal
        open={showPurchasePropertyModal}
        data={chatObj}
        property={chatObj?.property}
        onClose={() => setShowPurchasePropertyModal(false)}
      />
      {showAppointmentModal && chatObj.property?.id && (
        <Appointment
          chatId={chatObj.id}
          property={chatObj.property}
          propertyId={chatObj.property?.id}
          onClose={() => setShowAppointmentModal(false)}
        />
      )}
    </Wrapper>
  );
}
